/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';
import { SpaceVehiclePositionsBySvName } from '../../shared/entities/haloNet';

export const ActionCreators = {
  RequestHaloNetSpaceVehicles: new ActionCreator<'RequestHaloNetSpaceVehicles', any>('RequestHaloNetSpaceVehicles'),
  ReceivedHaloNetSpaceVehiclesSuccess: new ActionCreator<'ReceivedHaloNetSpaceVehiclesSuccess', any>(
    'ReceivedHaloNetSpaceVehiclesSuccess',
  ),
  ReceivedHaloNetSpaceVehiclesError: new ActionCreator<'ReceivedHaloNetSpaceVehiclesError', any>(
    'ReceivedHaloNetSpaceVehiclesError',
  ),

  RequestHaloNetSpaceVehicleOrbits: new ActionCreator<'RequestHaloNetSpaceVehicleOrbits', any>(
    'RequestHaloNetSpaceVehicleOrbits',
  ),
  ReceivedHaloNetSpaceVehicleOrbitsSuccess: new ActionCreator<'ReceivedHaloNetSpaceVehicleOrbitsSuccess', any>(
    'ReceivedHaloNetSpaceVehicleOrbitsSuccess',
  ),
  ReceivedHaloNetSpaceVehicleOrbitsError: new ActionCreator<'ReceivedHaloNetSpaceVehicleOrbitsError', any>(
    'ReceivedHaloNetSpaceVehicleOrbitsError',
  ),

  CancelHaloNetSpaceVehiclePolls: new ActionCreator<'CancelHaloNetSpaceVehiclePolls', any>(
    'CancelHaloNetSpaceVehiclePolls',
  ),
  UpdateHaloNetSpaceVehiclePositions: new ActionCreator<'UpdateHaloNetSpaceVehiclePositions', any>(
    'UpdateHaloNetSpaceVehiclePositions',
  ),
};

type ActionCreatorMap = typeof ActionCreators;
export type Action = ReturnType<ActionCreatorMap[keyof ActionCreatorMap]['create']>;

export function requestHaloNetSpaceVehicles() {
  return ActionCreators.RequestHaloNetSpaceVehicles.create();
}

export function requestHaloNetSpaceVehicleOrbits() {
  return ActionCreators.RequestHaloNetSpaceVehicleOrbits.create();
}

export function cancelHaloNetSpaceVehiclePolls() {
  return ActionCreators.CancelHaloNetSpaceVehiclePolls.create();
}

export function updateHaloNetSpaceVehiclePositions(positionsBySvName: SpaceVehiclePositionsBySvName) {
  return ActionCreators.UpdateHaloNetSpaceVehiclePositions.create({ positionsBySvName });
}
